export const institutionConsts = {
    GET_INSTITUTIONS_LIST: "GET_INSTITUTIONS_LIST",
    UPDATE_INSTITUTION_POSITIONS: "UPDATE_INSTITUTION_POSITIONS",
    CREATE_INSTITUTION: "CREATE_INSTITUTION",
    UPDATE_INSTITUTION: "UPDATE_INSTITUTION",
    DELETE_INSTITUTION_BY_ID: "DELETE_INSTITUTION_BY_ID",
};